const bodyElement = document.querySelector('body');
const mediaTabletBreakPoint = '(max-width: 840px)';
const mqTablet = window.matchMedia(mediaTabletBreakPoint);

const keyCode = Object.freeze({
    'TAB': 9,
    'RETURN': 13,
    'ESC': 27,
    'SPACE': 32,
    'PAGEUP': 33,
    'PAGEDOWN': 34,
    'END': 35,
    'HOME': 36,
    'LEFT': 37,
    'UP': 38,
    'RIGHT': 39,
    'DOWN': 40
});
class Utils {
    constructor () {
        this.IgnoreUtilFocusChanges = false;
    }

    focusFirstDescendant(element) {
        for (const childElem of element.childNodes) {
            if (this.attemptFocus(childElem) || this.focusFirstDescendant(childElem)) {
                return true;
            }
        }
        return false;
    }

    focusLastDescendant(element) {
        for (let i = element.childNodes.length - 1; i >= 0; i--) {
            const child = element.childNodes[i];
            if (this.attemptFocus(child) || this.focusLastDescendant(child)) {
              return true;
            }
        }
        return false;
    }

    attemptFocus(element) {
        // if (!this.isFocusable(element)) {
        //     return false;
        // }

        this.setIgnoreUtilFocusChanges = true;
        try {
            element.focus();
        } catch (e) {
        }
        this.IgnoreUtilFocusChanges = false;
        return (document.activeElement === element);
    }

    get getIgnoreUtilFocusChanges() {
        return this.IgnoreUtilFocusChanges;
    }

    set setIgnoreUtilFocusChanges(value) {
        return this.IgnoreUtilFocusChanges = value;
    }
}

const utils = new Utils();

class Dialog {
    constructor (dialogId, focusAfterClosed, focusFirst, nested, onClose) {
        this.utils = new Utils();
        this.dialogNode = document.querySelector(dialogId);
        this.handleTrapFocus = this.trapFocus.bind(this);
        this.nested = nested;
        this.onClose = onClose;

        if (this.dialogNode === null) {
            throw new Error('No element found with id="' + dialogId + '".');
        }
        this.dialogClose = this.dialogNode.querySelectorAll('.modal-close');

        const validRoles = ['dialog', 'alertdialog'];

        const isDialog = (this.dialogNode.getAttribute('role') || '').trim().split(/\s+/g)
            .some(function (token) {
                return validRoles.some(function (role) {
                    return token === role;
                });
            });
        if (!isDialog) {
            throw new Error(
            'Dialog() requires a DOM element with ARIA role of dialog or alertdialog.');
        }

        this.backdropNode = this.dialogNode.parentNode;
        this.backdropNode.classList.add('is-visible');
        this.backdropNode.style.opacity = 1;
        bodyElement.classList.add('modal-open');
        if (document.querySelector('.map-container') && document.querySelector('.map-container').contains(this.dialogNode) && !mqTablet.matches) {
            bodyElement.classList.remove('modal-open');
        }
        this.dialogNode.setAttribute('aria-hidden', false);

        if (!nested) {
            if (typeof focusAfterClosed === 'string') {
                this.focusAfterClosed = document.querySelector(focusAfterClosed);
            } else if (typeof focusAfterClosed === 'object') {
                this.focusAfterClosed = focusAfterClosed;
            } else {
                throw new Error('the focusAfterClosed parameter is required for the aria.Dialog constructor.');
            }

            if (typeof focusFirst === 'string') {
                this.focusFirst = this.dialogNode.querySelector(focusFirst);
            } else if (typeof focusFirst === 'object') {
                this.focusFirst = focusFirst;
            } else {
                this.focusFirst = null;
            }
        }

        const preDiv = document.createElement('div');
        this.preNode = this.dialogNode.parentNode.insertBefore(preDiv, this.dialogNode);
        this.preNode.tabIndex = 0;
        const postDiv = document.createElement('div');
        this.postNode = this.dialogNode.parentNode.insertBefore(postDiv, this.dialogNode.nextSibling);
        this.postNode.tabIndex = 0;

        if (this.openDialog) {
            this.openDialog.removeListeners();
        }

        this.addListeners();
        this.openDialog = this;
        this.clearDialog();

        if (!nested) {
            if (this.focusFirst) {
                this.focusFirst.focus();
            } else {
                this.utils.focusFirstDescendant(this.dialogNode);
            }
        }

        this.lastFocus = document.activeElement;
    }

    get getOpenDialog () {
        return this.openDialog;
    }

    clearDialog () {
        Array.prototype.map.call(this.dialogNode.querySelectorAll('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([type=submit]):not(.js-ignore)'), function (input) {
            input.value = '';
        });
    }

    close () {
        this.openDialog = null;
        this.removeListeners();
        this.dialogNode.parentNode.removeChild(this.preNode);
        this.dialogNode.parentNode.removeChild(this.postNode);
        this.backdropNode.style.opacity = 0;

        // delay 2.5s (see the setting in .modal-overlay#header-search in _modal.scss)
        var that = this;
        setTimeout(function() {
            that.backdropNode.classList.remove('is-visible');
            bodyElement.classList.remove('modal-open');
            that.dialogNode.setAttribute('aria-hidden', true);
        }, 250);
        
        // if (!this.nested) {
        //     this.focusAfterClosed.focus();
        // }
        this.onClose && this.onClose();
    }

    addListeners () {
        if (!this.nested) {
            document.addEventListener('focus', this.handleTrapFocus, true);
        }

        if (this.backdropNode && this.backdropNode.classList.contains('overlay-close')) {
            this.backdropNode.addEventListener('click', this.handleBackdropClick.bind(this), true);
        }

        if (this.dialogClose) {
            for (let item of this.dialogClose) {
                item.addEventListener('click', this.handleCloseClick.bind(this), true);
                item.addEventListener('keydown', this.handleCloseKeydown.bind(this), true);
            }
        }
    }

    removeListeners () {
        if (!this.nested) {
            document.removeEventListener('focus', this.handleTrapFocus, true);
        }
    }

    trapFocus (event) {
        if (this.utils.getIgnoreUtilFocusChanges) {
            return;
        }
        const currentDialog = this.openDialog;

        if (currentDialog.dialogNode.contains(event.target)) {
            currentDialog.lastFocus = event.target;
        } else {
            this.utils.focusFirstDescendant(currentDialog.dialogNode);
            if (currentDialog.lastFocus == document.activeElement) {
                this.utils.focusLastDescendant(currentDialog.dialogNode);
            }
            currentDialog.lastFocus = document.activeElement;
        }
    }

    handleCloseClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.openDialog) {
            this.openDialog.close();
        }
    }

    handleCloseKeydown(event) {
        let flag = false;

        switch (event.keyCode) {
            case keyCode.SPACE:
            case keyCode.RETURN:
                if (this.openDialog) {
                    this.openDialog.close();
                }
                flag = true;
                break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    handleBackdropClick(event) {
        // don't close if clicking on main modal content
        if (event.target.closest('.js-modal-main-content')) return;

        event.preventDefault();
        event.stopPropagation();
        if (this.openDialog) this.openDialog.close();
    }
}

const openModalContrs = document.querySelectorAll('.js-open-modal');
const mediaBreakPoint = '(max-width: 1024px)';
const mq = window.matchMedia(mediaBreakPoint);

const initDialog = (modalContr) => {
    const targetModalId = modalContr.dataset.target;
    let targetModalObj = null;

    modalContr.addEventListener('click', function(eve) {
        eve.preventDefault();
        targetModalObj = new Dialog(targetModalId, this, 'input', targetModalId === '#viewBrochureModal');

        document.onkeyup = function(event) {
            const keyCode = event.which || event.keyCode;
            if (keyCode === 27) {
                event.stopPropagation();
                targetModalObj.getOpenDialog.close();
            }
        };
    });
}

for (const modalContr of openModalContrs) {
    initDialog(modalContr);
}

export { initDialog, Dialog };